import { IPage, ISearchPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";

//详情
export interface IReceivableDetail {
    id: string;
    code: string;
    addAmount?:string, // 121
    batches?:string, // "0"
    bentityCode?:string, // "bentity.yhcy"
    bentityName?:string, // "云湖春煜（天津）资产管理有限公司"
    clause?:string, // "trade-fob"
    contact?:string, // "陈"
    contractAmount?:string, // 11971
    countryCode?:string, // "ALGERIA"
    countryName?:string, // "ALGERIA 阿尔及利亚"
    createTime?:string, // "2022-04-28 20:26:31"
    createUser?:string, // "陈彦晓"
    cumulative?:string, // 9998
    currencyCode?:string, // "gtm.currency.usd"
    currencyName?:string, // "USD"
    customerCode?:string, // "CUS-M-00018724"
    customerId?:string, // "de7c7fadc892899a6dbe92daab5a7523"
    customerName?:string, // "北京大大"
    deleteFlag?:string, // 0
    exchangeRate?:string, // "6.78"
    goodsAmount?:string, // 11971
    note?:string, // "离开"
    offerCode?:string, // "B-AAI-2205"
    orderNum?:string, // 0
    payStatus?:string, // "pay-status.bill"
    phone?:string, // "121212"
    reckoner?:string, // "管理员"
    relevanceOrderId?:string, // "864725870641478fa6e566b2b66afb7d"
    rmbAmount?:string, // 0
    settlementTime?:string, // "2022-04-28 21:33:10"
    shippingTime?:string, // "2022-04-28 21:33:14"
    shopCode?:string, // "SHOP-M-00000102"
    shopName?:string, // "云湖门店"
    status?:string, // "sales.ship"
    transship?:string, // "0"
    typeNum?:string, // 2
    uncollected?:string, // 998
    updateTime?:string, // "2022-04-28 20:27:15"
    updateUser?:string, // "陈彦晓"
    currency?:string, // "陈彦晓"
}

//新增
export interface IReceivableInsert extends IReceivableDetail { }

//编辑
export interface IReceivableUpdate extends IReceivableInsert {
    id: string;
}

//搜索条件
export interface IReceivableSearchFields { }

export interface IReceivableSearch extends IReceivableSearchFields, ISearchPage { }



class ReceivableService {
    async page(searchVo: IReceivableSearch, config: object = {}) {
        const apiUrl = "/gtm/standingBooking/payable";
        return await httpRequest.post<IPage<IReceivableDetail>>(apiUrl, searchVo, config);
    }

    //导出
    async export(searchVo: IReceivableSearch) {
        const appPageUrl = "/gtm/standingBooking/payable/export";
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 });
    }
    //下载模板
    async downloadTpl() {
        const appPageUrl = "/gtm/sale/downloadTpl";
        return await httpRequest.getFile(appPageUrl);
    }

}

export const receivableService = new ReceivableService();
